import { styled } from "styled-components";

export const ContentsSlideContainer = styled.div`
  position: relative;
`;

export const HomeContentsSlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HomeContentsSlideContainer = styled.ul``;

export const HomeContentsSlideImgWrap = styled.div`
  width: 100%;
  height: 372px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #efefef;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media all and (max-width: 1180px) {
    height: 31.525vw;
  }
  @media all and (max-width: 768px) {
    height: 38vw;
  }
`;

export const HomeContentsSlideTextWrapper = styled.div`
  height: 100%;
`;
export const HomeContentsSlideTextWrap = styled.div`
  .title-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    text-align: left;
    h6 {
      font-size: 16px;
      line-height: 1.5;
      color: #555;
      font-weight: bold;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 최대 2줄까지 표시 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    }
    p {
      font-size: 14px;
      line-height: 1.4;
      color: #6f6f6f;

      display: -webkit-box;
      -webkit-line-clamp: 2; /* 최대 2줄까지 표시 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    }
    span {
      font-size: 12px;
      line-height: 1.3;
      color: #6f6f6f;
    }
  }
  @media all and (max-width: 768px) {
    .title-wrap {
      h6 {
        font-size: 3.646vw;
      }
      p {
        font-size: 3.385vw;
      }
      span {
        font-size: 3.125vw;
      }
    }
  }
`;

export const ContentsSlidPrevButton = styled.button`
  position: absolute;
  top: 50%;
  left: -90px;
  z-index: 20;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  appearance: none;
  background: transparent;
  border: 0 none;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
  }
  @media all and (max-width: 1400px) {
    display: none;
  }
`;
export const ContentsSlidNextButton = styled.button`
  position: absolute;
  top: 50%;
  right: -90px;
  z-index: 20;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  appearance: none;
  background: transparent;
  border: 0 none;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
  }
  @media all and (max-width: 1400px) {
    display: none;
  }
`;

export const ViewMoreButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  a {
    width: 122px;
    height: 32px;
    background-color: #f5f4f3;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    font-size: 16px;
    color: #171717;
  }

  @media all and (max-width: 768px) {
    margin-top: 5.208vw;
    a {
      width: 26.042vw;
      height: 5.859vw;
      font-size: 3.646vw;
    }
  }
`;
